import { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import SiteFooter from './SiteFooter'

interface LegalLayoutProps {
  title: string
  tagline: string
  effectiveDate: string
  children: ReactNode
}

export default function LegalLayout({ title, tagline, effectiveDate, children }: LegalLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-warm-white">
      <header className="bg-ink-primary px-8 pb-10 pt-12 text-center text-warm-white sm:px-6">
        <h1 className="font-serif text-[1.5rem] font-normal tracking-[-0.02em] sm:text-[2rem]">
          {title}
        </h1>
        <p className="mt-1.5 text-[0.95rem] font-light text-white/50">{tagline}</p>
        <Link
          to="/"
          className="mt-5 inline-flex items-center gap-2 rounded-lg border border-white/10 bg-white/[0.08] px-4 py-2 text-sm text-white/60 no-underline transition-colors hover:bg-white/[0.14] hover:text-warm-white"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M15 18l-6-6 6-6" />
          </svg>
          Back to Pelvia
        </Link>
      </header>

      <main className="mx-auto w-full max-w-[780px] flex-1 px-5 py-8 sm:px-8 sm:py-12">
        <div className="mb-8 border-b border-border-light pb-4 text-[0.85rem] italic text-ink-tertiary">
          Effective date: {effectiveDate}
        </div>
        <div className="legal-content text-[0.95rem] text-ink-secondary">{children}</div>
      </main>

      <SiteFooter />
    </div>
  )
}
